export const BASE_PATH = "https://api.mainnet.hiro.so";
